import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import InputMasked from "react-input-mask";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
// Components
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import ModalShare from "../../../components/ModalShare";
import Select from "../../../components/Select";
import Main from "../../../components/Main/index";
import ErrorMessage from "../../../components/ErrorMessage";
// Routes
import routes from "../../../routes/pix.routes";
// Styles
import { ContainerForm, Legend, Button } from "./styles";
import api from "../../../service/api";
// Helpers
import { openModal } from "../../../helpers/modalFunctions";
// Utils
import convertAmountInCents from "../../../utils/amountInCents";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import ModalWarning from "../../../components/ModalWarning";
import { sendWhatsapp } from "../../../utils/sendPaymentLink/sendWhatsapp";
import { sendEmail } from "../../../utils/sendPaymentLink/sendEmail";
import { ETypeTransactions } from "../../../utils/typeTransactions";

const PixPaymentLink = () => {
    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    const isChurch: boolean = login.user.groups.cm8;

    const [buyer, setBuyer] = useState({
        email: "",
        phoneNumber: ""
    });
    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);
    const [message, setMessage] = useState("");
    const [phoneNumberPrefix, setPhoneNumberPrefix] = useState("55");

    const [linkId, setLinkId] = useState({
        id: "",
        url: "",
        value: "",
        description: "",
        establishment: "",
    });
    
    const formValidationWithYup = Yup.object().shape({
        value: Yup.string().required(),
        description: Yup.string().required(),
        phoneSms: Yup.string(),
        email: Yup.string().email(),
    })
    
    useEffect(() => {
        if(login.user.groups.cm7a2 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const searchForErrors = (errors: Object) => {
        if(errors !== {}){
            setErrorOnSubmit(true)
        } else {
            setErrorOnSubmit(false)
        }
    }

    const sendInWhatsapp = async () => {
        const { message } = await sendWhatsapp({
            link: linkId.url,
            phoneSms: buyer.phoneNumber,
            amount: linkId.value,
            establishment: login.user.branchs.businessName,
            description: linkId.description,
            endpoint: "/pix/send/whats"
        })
        
        setMessage(message)
    }

    const sendInEmail = async () => {
        const { message } = await sendEmail({
            email: buyer.email,
            link: linkId.url,
            id: linkId.id,
            establishment: login.user.branchs.businessName,
            endpoint: "/pix/send/email"
        })
        
        setMessage(message)
    }

    const handlePhoneNumberPrefixChange = (e: string) => {
        setPhoneNumberPrefix(e);
    }

    return(
        <Main>
            <ToastContainer/>
            <ModalWarning 
                title="Logo não identificada"             
                description="Para criar links de pagamentos, é necessário fazer o upload da logo da sua empresa. Deseja ir para configurações?" 
                pathBack="/admin/pix/instructions-pix"
                pathGo="/admin/configuration/my-cadastre"
            />
            <Header title="PIX" 
                subTitle="Gere um código Pix, compartilhe o link e faça suas cobranças." 
                subTitleWidth={200}/>
            <NavTabs tabs={routes}/>
            <ModalShare 
                text={isChurch ? "QR Code gerado com sucesso"  : "Link gerado com sucesso"}
                linkId={linkId.url}
                type={ETypeTransactions.PIX}
                sendEmail={sendInEmail}
                sendWhatsapp={sendInWhatsapp}
                message={message}
                qrCode={isChurch}
            />

            <Formik 
                initialValues={{
                    value: "",
                    description: "",
                    phoneSms: "",
                    email: "",
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    let amountInCents = convertAmountInCents(values.value)

                    const phoneNumber = values.phoneSms.replace("(", "").replace(")", "").replace("-", "").split(" ").join("");

                    setBuyer({
                        email: values.email,
                        phoneNumber: `${phoneNumberPrefix}${phoneNumber}`
                    })

                    try {
                        const { data } = await api.post("/pix/authorization/create",{
                            "amount": amountInCents.toString(),
                            "description": values.description,
                            "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                            "branchsId": login.user.branchsId,
                            "phoneSms": buyer.phoneNumber,
                            "standardLogo": login.user.branchs.standardLogo,
                            "email": buyer.email,
                        }, {
                            params: {
                                "portal": true
                            }
                        })

                        setLinkId({
                            id: data.id,
                            url: `https://100pay-payment-link.netlify.app/payment-pix/${data.id}/${login.token}`,
                            value: amountInCents.toString(),
                            description: values.description,
                            establishment: login.user.branchs.businessDescription,
                        });
                        setErrorOnReturnApi(false);
                        openModal("exampleModal");
                        toastUpdate("btnSubmit", "success", 3000, "Pix gerado com sucesso")
                    } catch (e) {
                        setErrorOnReturnApi(true);
                        toastUpdate("btnSubmit", "error", 4000, "Ocorreu um problema, entre em contato com o suporte.")
                    }
                }}
            >
                {({errors, values, handleChange}) => {
                return (
                    <ContainerForm>
                    <fieldset>
                        <Legend>Gerar um link para pagamento</Legend>
                        
                        <Form>
                        <div id="contacts">
                            <div className="d-flex col-12 p-0">
                                <div className="col-3 p-0 pr-2">
                                    <Select value={phoneNumberPrefix} onChange={(e) => handlePhoneNumberPrefixChange(e.target.value)}>
                                        <option disabled hidden value={phoneNumberPrefix}>+{phoneNumberPrefix}</option>
                                        <option value="55">Brasil (55)</option>
                                        <option value="598">Uruguai (598)</option>
                                        <option value="1">Estados Unidos (1)</option>
                                        <option value="52">México (52)</option>
                                    </Select>
                                </div>
                                <div className="col-9 p-0">
                                    <Field name="phoneSms">
                                        {() => (
                                            <InputMasked
                                                id="phoneSms"
                                                className="input-masked inputCustom" 
                                                style={{borderColor: `${errorOnSubmit && errors.phoneSms ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                placeholder="Telefone"
                                                mask={phoneNumberPrefix === "55" ? "(99) 99999-9999" : ""} //(99) 99999-9999
                                                value={values.phoneSms}
                                                type="tel"
                                                onChange={handleChange}
                                            />
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <Field
                                id="email"
                                name="email"
                                className="inputCustom" 
                                placeholder="Email" 
                                type="email"
                                as={Input}
                            />
                        </div>
                        <Field id="value" name="value" 
                            className="inputCustom" placeholder="Valor" 
                            style={{borderColor: `${errorOnSubmit && errors.value ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                            type="text"
                            as={Input}
                        />

                        <Field id="description" name="description" 
                            className="inputCustom" placeholder="Descrição da cobrança"
                            style={{borderColor: `${errorOnSubmit && errors.description ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                            as={Input}
                        />
                            {notifysFieldsForm(errors, errorOnSubmit)}
                            {
                                errorOnReturnApi ?
                                    <ErrorMessage>
                                        Falha ao gerar código Pix
                                    </ErrorMessage> : null
                            }
                            <Button
                                type="submit"
                                onClick={() => {
                                    searchForErrors(errors)
                                    toastCreate("btnSubmit", "info", 2000, "Processando...")
                                }}
                            >Gerar Pix</Button>
                        </Form>
                    </fieldset>
                </ContainerForm>
                )
            }}
            </Formik>
        </Main>
    )
}

export default PixPaymentLink;